import { useReducer } from 'react';

const initialConfig = {
  photos: [
    {
      position: 0,
      photo: null,
    },
    {
      position: 1,
      photo: null,
    },
  ],
  emoji: null,
  identityName: '',
  cabinName: '',
  externalShippingAddressId: '',
  caption: '',
};

const SET_PHOTO = 'SET_PHOTO';
const SET_PHOTO_CROPBOX = 'SET_PHOTO_CROPBOX';
const SET_CAPTION = 'SET_CAPTION';
const SET_CABIN_NAME = 'SET_CABIN_NAME';
const SET_IDENTITY_NAME = 'SET_IDENTITY_NAME';
const SET_EMOJI = 'SET_EMOJI';
const RESET = 'RESET';

const reducer = (state, action) => {
  switch (action.type) {
    case SET_PHOTO:
      return {
        ...state,
        // Nullify the user uploaded image if need be.
        photos: state.photos.map(photo => {
          if (photo.position === action.position) {
            return {
              position: action.position,
              photo: action.photo,
            };
          }

          return photo;
        }),
      };

    case SET_PHOTO_CROPBOX:
      return {
        ...state,
        photos: state.photos.map(photo => {
          if (photo.position === action.position) {
            return {
              ...photo,
              cropbox: action.cropbox,
            };
          }

          return photo;
        }),
      };

    case SET_CAPTION: {
      return {
        ...state,
        caption: action.caption,
      };
    }

    case SET_CABIN_NAME:
      return {
        ...state,
        cabinName: action.cabinName.slice(0, 40),
      };

    case SET_IDENTITY_NAME:
      return {
        ...state,
        identityName: action.identityName.slice(0, 40),
      };

    case SET_EMOJI:
      return {
        ...state,
        emoji: action.emoji,
      };

    case RESET:
      return initialConfig;

    default:
      return state;
  }
};

/**
 * Waldogram configuration hook.
 *
 * @param {Object} [configOverrides] - Any optional config overrides.
 * @returns {{dispatch: React.Dispatch<React.ReducerAction<reducer>>, setPhoto: (function(*, *): void), setPhotoCropbox: (function(*, *): void), setCaption: (function(*): void), setEmoji: (function(*): void), config: React.ReducerState<reducer>, setIdentityName: (function(*): void), setCabinName: (function(*): void), resetWaldogram: (function(): void)}}
 */
const useWaldogramConfig = (configOverrides = {}) => {
  const [config, dispatch] = useReducer(reducer, {
    ...initialConfig,
    ...configOverrides,
  });

  return {
    config,
    dispatch,
    setPhoto: (position, photo) =>
      dispatch({
        type: SET_PHOTO,
        position,
        photo,
      }),
    setPhotoCropbox: (position, cropbox) =>
      dispatch({
        type: SET_PHOTO_CROPBOX,
        position,
        cropbox,
      }),
    setCaption: caption =>
      dispatch({
        type: SET_CAPTION,
        caption,
      }),
    setCabinName: cabinName =>
      dispatch({
        type: SET_CABIN_NAME,
        cabinName,
      }),
    setIdentityName: identityName =>
      dispatch({
        type: SET_IDENTITY_NAME,
        identityName,
      }),
    setEmoji: emoji =>
      dispatch({
        type: SET_EMOJI,
        emoji,
      }),
    resetWaldogram: () =>
      dispatch({
        type: RESET,
      }),
  };
};

export default useWaldogramConfig;
